window.TV2 = window.TV2 || {};

(function () {
  const shareButton = document.querySelector('.share-button');

  if (shareButton && navigator.share) {
    shareButton.classList.add('share-button--visible');
  }

  window.TV2.sharePage = (title, url) => {
    window.dataLayer.push({
      event: 'interaction',
      eventCategory: 'Social Interaction',
      eventAction: 'Article - Share button',
    });
    navigator.share({
      title,
      url,
    });
  };
})();
